import { transformExtent } from "ol/proj";
import { MapTool, requestTool } from "../tools";

const getFeatureInfo = (mapToolRef, coordinates, layer, feature, checkIdentifierColumn) => {

    let url = getFeatureInfoUrl(mapToolRef, {
        layerName: layer,
        coordinates,
        pixelRadius: 5,
        featureCount: 10,
        feature,
        checkIdentifierColumn: checkIdentifierColumn
    });

    return requestTool.getRequest(url);
}

const getFeatureInfoUrl = (mapToolRef, options) => {

    const url = mapToolRef.getLayerSource(options.layerName).
        getFeatureInfoUrl(options.coordinates,
            mapToolRef.getResolution(),
            mapToolRef.getProjection(),
            {
                'INFO_FORMAT': 'application/json',
                'PIXELRADIUS': options.pixelRadius,
                'FEATURE_COUNT': options.featureCount,
                'COORDINATEWKT': MapTool.convertToWkt(options.feature, mapToolRef.wktProjection, mapToolRef.mapProjection),
                'CHECKIDENTIFIERCOLUMN': options.checkIdentifierColumn
            });

    return url.replace("/getmap?", "/getfeatureinfo?");
}

const executeRule = (item, url) => requestTool.
    postRequest(url + "/api/DynamicRule/ExecuteRule", item);

const getIdentifierInfo = (url, item) => requestTool.
    postRequest(url + "/api/proxy/GetWfsIdentifierColumn", item);

export const infoService = {
    getFeatureInfo,
    executeRule,
    getIdentifierInfo
};

export default infoService;

